import { t } from "i18next";
import { setErrorsFromResponseData } from "../../../../components/BuildingBlocks/Forms/utils/setErrorsFromResponseData";
import { useToast } from "../../../../mantine/notifications/useToast";
import type {
  ExpressOnboardingEegColumnProps,
  ExpressOnboardingGenerator
} from "../../ExpressOnboarding.types";
import { getExpressOnboardingEegSave } from "../utils/getExpressOnboardingEegSave";
import { useExpressOnboardingMutations } from "./useExpressOnboardingMutations";

function useExpressOnboardingEegSave(
  generator: ExpressOnboardingGenerator,
  { getDraft, setError, clearDraft }: ExpressOnboardingEegColumnProps
) {
  const { expressOnboardingGeneratorSave, pendingGeneratorIds } =
    useExpressOnboardingMutations();
  const { showErrorToast } = useToast();

  const save = (change: Partial<ExpressOnboardingGenerator>) => {
    const { patch, errors } = getExpressOnboardingEegSave(
      generator,
      getDraft(generator.id),
      change
    );
    setError(generator.id, errors);
    if (Object.keys(errors).length > 0) {
      return;
    }

    expressOnboardingGeneratorSave
      .mutateAsync({ id: generator.id, ...patch })
      .then(() => {
        for (const field of Object.keys(patch)) {
          clearDraft(generator.id, field as keyof ExpressOnboardingGenerator);
        }
      })
      .catch((error) => {
        setErrorsFromResponseData(
          showErrorToast,
          error,
          generator,
          (field: string, err: { message?: string }) =>
            setError(generator.id, {
              [field]: err?.message ?? t("errors.UnknownError")
            }),
          t("errors.UnknownError")
        );
      });
  };

  return { save, rowIsSaving: pendingGeneratorIds.has(generator.id) };
}

export { useExpressOnboardingEegSave };
